import { useSyncExternalStore } from "react";

/** A table is a market: `/` is Bitcoin's, `/eth` Ether's. */
export type Route = { view: "table"; coin: string } | { view: "bets" } | { view: "wallet" };

export const HOME_COIN = "BTC";

export function parse(pathname: string): Route {
  const [first] = pathname.split("/").filter(Boolean);
  switch (first) {
    case "bets":
      return { view: "bets" };
    case "wallet":
      return { view: "wallet" };
    default:
      return { view: "table", coin: first && /^[a-z0-9]{2,10}$/i.test(first) ? first.toUpperCase() : HOME_COIN };
  }
}

export function href(route: Route): string {
  if (route.view === "table") return route.coin === HOME_COIN ? "/" : `/${route.coin.toLowerCase()}`;
  return `/${route.view}`;
}

export const tableHref = (coin: string) => href({ view: "table", coin });

const listeners = new Set<() => void>();
const notify = () => listeners.forEach((listener) => listener());
window.addEventListener("popstate", notify);

export function navigate(to: string, replace = false, keepScroll = false): void {
  if (to === window.location.pathname) return;
  if (replace) window.history.replaceState(null, "", to);
  else window.history.pushState(null, "", to);
  if (!keepScroll) window.scrollTo({ top: 0 });
  notify();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function usePathname(): string {
  return useSyncExternalStore(subscribe, () => window.location.pathname);
}

export function useRoute(): Route {
  return parse(usePathname());
}
